import GridyCommon from '@/modules/gridy_common';
import I18n from '@/modules/i18n';
import ModuleLoader from '@/modules/module_loader';
import Templates from '@/pages/site/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  connect() {
    this.grid = $(this.element).find('[data-gridy]');
    this.options = ModuleLoader.getOptions();

    GridyCommon.gridy(this.grid, { url: this.options.gridy.url, ...this.gridyOptions() });
  }

  gridyOptions() {
    return {
      headers: [
        { name: I18n.t('activerecord.attributes.payment_account.name'), value: 'payment_accounts.name' },
        {
          name: I18n.t('activerecord.attributes.payment_account.credit_card_description'),
          value: 'payment_accounts.credit_card_description',
        },
        { name: I18n.t('activerecord.attributes.payment_account.person_type') },
        { name: I18n.t('document.one') },
        { name: I18n.t('activerecord.models.bank.one'), value: 'banks.name' },
        { name: I18n.t('activerecord.attributes.payment_account.bank_account.kind') },
        { name: I18n.t('activerecord.attributes.payment_account.bank_account.number'), value: 'bank_accounts.number' },
        { name: I18n.t('activerecord.attributes.payment_account.default'), value: 'payment_accounts.default' },
        { name: I18n.t('action.other'), value: '' },
      ],

      idSortName: 'payment_accounts.id',
      idSortOrder: 'desc',
      sortName: 'payment_accounts.created_at',
      sortOrder: 'desc',
      template: Templates.payment_accounts.gridy,
    };
  }
}
